import { PlanType } from "../requestDefines";

export class insurance{
    orgId: string = '';
    planType: PlanType = PlanType.none;
    remainAiChat: number = 0;
    remaincare: number = 0;
    allowUseIntroduce: boolean = false;
}
